import { isNumber } from './is-number'

export function isArrayNumber(value: number[]): boolean {
  for (const i of value) {
    if (!isNumber(value[i])) {
      return false
    }
  }
  return true
}
